export const VIEW_PERMISSIONS = {
  OVERVIEW: {
    VIEW: 'views.view_overview_view',
    CHANGE: 'views.change_overview_view',
    DELETE: 'views.delete_overview_view',
  },
  CMA_SUMMARY: {
    VIEW: 'views.view_cma_summary_view',
    CHANGE: 'views.change_cma_summary_view',
    DELETE: 'views.delete_cma_summary_view',
  },
  SALES_BATTLECARD: {
    VIEW: 'views.view_sales_battlecard_view',
    CHANGE: 'views.change_sales_battlecard_view',
    DELETE: 'views.delete_sales_battlecard_view',
  },
  CUSTOM: {
    VIEW: 'views.view_custom_view',
    ADD: 'views.add_custom_view',
    CHANGE: 'views.change_custom_view',
    DELETE: 'views.delete_custom_view',
  },
  LEGACY: {
    VIEW: 'views.view_view',
    ADD: 'views.add_view',
    CHANGE: 'views.change_view',
    DELETE: 'views.delete_view',
  },
} as const;
